module.exports = __webpack_public_path__ + "img/ca.83768f02.png";